class NEventManager {
    constructor (eventNames) {
        this.events = new Map()
        this.onces = new Map()

        eventNames = eventNames || []

        eventNames.forEach(eventName => {
            this.registerEvent(eventName)
        })
    }

    registerEvent (eventName) {
        if (!this.events.has(eventName)) {
            this.events.set(eventName, new Set())
            this.onces.set(eventName, new Set())
        }
    }

    unregisterEvent (eventName) {
        this.onces.delete(eventName)
        return this.events.delete(eventName)
    }

    hasEvent (eventName) {
        return this.events.has(eventName)
    }

    hasHandler (eventName) {
        return this.hasEvent(eventName) &&
            this.events.get(eventName).size > 0
    }

    on (eventName, handler) {
        if (this.events.has(eventName)) {
            this.events.get(eventName).add(handler)
        }
    }

    once (eventName, handler) {
        if (this.events.has(eventName)) {
            this.on(eventName, handler)
            this.onces.get(eventName).add(handler)
        }
    }

    off (eventName, handler) {
        if (!this.events.has(eventName)) {
            return
        }

        if (handler) {
            this.events.get(eventName).delete(handler)
            this.onces.get(eventName).delete(handler)
        } else {
            this.events.get(eventName).clear()
            this.onces.get(eventName).clear()
        }
    }

    trigger (eventName, data) {
        const handlers = this.events.get(eventName)

        if (!handlers) {
            return
        }

        const eventData = data === Object(data)
            ? data
            : {}

        eventData.event = eventName

        const handlersToRun = Array.from(handlers)

        handlersToRun.forEach(handler => {
            handler(eventData)

            if (this.onces.get(eventName).has(handler)) {
                this.off(eventName, handler)
            }
        })
    }
}

export class NEventable {
    constructor (events) {
        Object.defineProperty(this, '_eventManager', {
            value: new NEventManager(events)
        })
    }

    registerEvent (eventName) {
        this._eventManager.registerEvent(eventName)
    }

    unregisterEvent (eventName) {
        return this._eventManager.unregisterEvent(eventName)
    }

    hasEvent (eventName) {
        return this._eventManager.hasEvent(eventName)
    }

    hasHandler (eventName) {
        return this._eventManager.hasHandler(eventName)
    }

    on (eventName, handler) {
        this._eventManager.on(eventName, handler)
    }

    once (eventName, handler) {
        this._eventManager.once(eventName, handler)
    }

    off (eventName, handler) {
        this._eventManager.off(eventName, handler)
    }

    trigger (eventName, data) {
        this._eventManager.trigger(eventName, data)
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/npopup/NEventable.js